export const routeToCpdPage = 'central-project-data';
export const routeToMembersPage = 'members';
export const routeToDocumentsPage = 'documents';

export const configItemIdRouteParam = 'configItemId';
